import { tokens } from 'src/design-system';

export const styles = () => ({
    modal: {
      minWidth: '870px',
      '& .ant-modal-body': {
        paddingBottom: '60px',
      },
    },
    tabStyle: {
      '& .ant-tabs-nav .ant-tabs-tab': {
        padding: '10px 24px',
        margin: 0,
      },
      '& .ant-tabs-bar': {
        borderBottom: 'unset',
        marginBottom: 0,
        marginLeft: '10px',
      },
      '& .ant-tabs-nav .ant-tabs-tab-active': {
        color: '#3797F7',
      },
      '& .ant-tabs-ink-bar ': {
        backgroundColor: tokens.colors.primary,
        height: '5px',
        width: '74px',
      },
    },
    tabContent: {
      fontSize: `${tokens.fontSize.small}px`,
      border: '1px solid #E0E0E0',
      borderRadius: `${tokens.radius.md}px`,
      padding: `${tokens.spacing.md}px`,
      minHeight: '280px',
    },
    uploadStyle: {
      marginTop: `${tokens.spacing.md}px`,
      height: '180px !important',
      '& .ant-upload-drag-container': {
        display: 'flex !important',
        flexDirection: 'column !important',
      },
    },
    uploadText: {
      marginBottom: tokens.spacing.md,
      fontSize: `${tokens.fontSize.small}px`,
      color: '#9F9F9F',
    },
    uploadButton: {
      backgroundColor: tokens.colors.primary,
      border: `1px solid ${tokens.colors.primary}`,
      color: tokens.colors.bgWhite,
      marginLeft: '15px',
      '&:focus': {
        backgroundColor: tokens.colors.primary,
        border: `1px solid ${tokens.colors.primary}`,
        color: tokens.colors.bgWhite,
      },
      '&:hover': {
        backgroundColor: tokens.colors.primary,
        border: `1px solid ${tokens.colors.primary}`,
        color: tokens.colors.bgWhite,
      },
    },
    fileName: {
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
    },
    scrollbar: {
      '&::-webkit-scrollbar:vertical': {
        width: '11px',
      },
      '&::-webkit-scrollbar:horizontal': {
        height: '11px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: `${tokens.radius.lg}px`,
        border: '2px solid white',
        backgroundColor: 'rgba(0, 0, 0, .5)',
      },
      '&::-webkit-scrollbar': {
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none',
      },
    },
    uploadStepText: {
      fontWeight: tokens.fontWeight.semibold,
      fontSize: `${tokens.fontSize.body}px`,
    },
    formLabel: {
      marginTop: `${tokens.spacing.ms}px`,
      fontSize: `${tokens.fontSize.small}px`,
      fontWeight: tokens.fontWeight.semibold,
      color: tokens.colors.textSecondary,
    },
    select: {
      minWidth: '70%',
      width: 'auto',
    },
    form: {
      '& .ant-form-item': {
        marginBottom: `${tokens.spacing.sm}px`,
      },
    },
    dragnDropText: {
      fontSize: `${tokens.fontSize.small}px`,
      color: '#525252',
      marginBottom: 5,
    },
    downloadFileCol: {
      paddingRight: '20px',
      borderRight: '1px solid #E0E0E0',
      minHeight: '240px',
    },
    downloadFileText: {
      color: tokens.colors.primary,
      cursor: 'pointer',
      position: 'absolute',
      bottom: 0,
    },
    centerDiv: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }
  });
